<template>
  <div class="cvs-wrapper">
    <!-- company-profile display -->
    <div class="company-profile-container" v-animate-css="'fadeIn'">
      <div class="company-profile-body">
        <div class="cvs-item-header">
          <label class="title" v-if="section_type == 'all-cv'">All CV templates</label>
          <label class="title" v-if="section_type == 'my-cv'">My CVs</label>
          <div class="options">
            <button class="add-btn" @click="show_add_cv_modal = true">
              Upload CV +
            </button>
            <dropdown-menu>
              <ul>
                <li>
                  <a href @click.prevent="switchSection('all-cv')">All CV templates</a>
                </li>
                <li>
                  <a href @click.prevent="switchSection('my-cv')">My CVs</a>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>

        <!-- All CV templates -->
        <div class="cvs-item-header" v-if="cvs_data.length > 0 && section_type == 'all-cv'">
          <label>Custom CV templates</label>
        </div>
        <div class="cvs-items" v-if="section_type == 'all-cv'">
          <div class="cv-item" v-for="(item, index) in cvs_data" :key="index">
            <div class="cv-item-header">
              <label>{{ item.alias | validate }}</label>
              <dropdown-menu>
                <ul>
                  <li>
                    <a href @click.prevent="download('custom', item.name)">Download</a>
                  </li>
                  <li>
                    <a href @click.prevent="appyTemp('custom', item.id)">Apply</a>
                  </li>
                  <li>
                    <a href @click.prevent="removeTemp(item.id)">Remove</a>
                  </li>
                </ul>
              </dropdown-menu>
            </div>
            <div class="cv-item-body">
              <img src="@/assets/images/temp_docs/new/cv_tumbnail.svg" />
            </div>
          </div>
        </div>

        <!-- Default cv -->
        <div class="cvs-item-header" v-if="section_type == 'all-cv'" style="margin-top: 40px">
          <label>Default CV templates</label>
        </div>
        <div class="cvs-items" v-if="section_type == 'all-cv'">
          <div class="cv-item" v-for="(n, index) in 4" :key="index">
            <div class="cv-item-header">
              <label v-if="n == 1">Basic</label>
              <label v-if="n == 2">Vanilla</label>
              <label v-if="n == 3">Classic</label>
              <label v-if="n == 4">Fancy</label>
              <dropdown-menu>
                <ul>
                  <li>
                    <a href @click.prevent="download('default', n)">Download</a>
                  </li>
                  <li>
                    <a href @click.prevent="appyTemp('default', n)">Apply</a>
                  </li>
                </ul>
              </dropdown-menu>
            </div>
            <div class="cv-item-body">
              <img v-if="n == 1" src="@/assets/images/temp_docs/new/1.svg" />
              <img v-if="n == 2" src="@/assets/images/temp_docs/new/2.svg" />
              <img v-if="n == 3" src="@/assets/images/temp_docs/new/3.svg" />
              <img v-if="n == 4" src="@/assets/images/temp_docs/new/4.svg" />
            </div>
          </div>
        </div>

        <!-- My CVs -->
        <div class="forder-section" v-if="section_type == 'my-cv'">
          <div class="header">
            <div class="option">
              <button class="btn-create-folder" v-if="cv_file_form.path != '/'" @click="DirBack()">
                Back
              </button>
            </div>
            <div class="option">
              <button class="btn-create-folder" @click="create_folder_widget = !create_folder_widget">
                Create Folder
              </button>
            </div>
          </div>
          <div class="path">{{ cv_file_form.path | validate }}</div>
          <div class="body">
            <div class="folder-creation-input" v-if="create_folder_widget">
              <div class="brand">
                <img src="@/assets/file-icon/folder.svg" />
              </div>
              <div class="content">
                <input type="text" class="folder-name-input" placeholder="Folder name" v-model="folder_form.name" />
              </div>
              <div class="options">
                <button class="btn-add-folder" @click="createFolder()">
                  Add +
                </button>
              </div>
            </div>
            <template v-for="(item, index) in cv_file_manager">
              <div class="file-folder-item" :key="index" v-if="isFile(item)">
                <div class="brand">
                  <img v-if="fileExt(item) == 'docx'" src="@/assets/file-icon/word.svg" />
                  <img v-else-if="fileExt(item) == 'pdf'" width="20" src="@/assets/file-icon/pdf.svg" />
                  <img v-else-if="fileExt(item) == 'json'" src="@/assets/file-icon/json.svg" />
                  <img v-else-if="
                    fileExt(item) == 'png' ||
                    fileExt(item) == 'jpg' ||
                    fileExt(item) == 'jpeg' ||
                    fileExt(item) == 'svg'
                  " src="@/assets/file-icon/image.svg" width="20" />
                  <img v-else width="20" src="@/assets/file-icon/file.svg" />
                </div>
                <div class="content">
                  <div class="content-title">
                    <label>{{ item | validate }}</label>
                  </div>
                  <div class="date"></div>
                </div>
                <div class="options">
                  <dropdown-menu>
                    <ul>
                      <li>
                        <app-dialog title="File Deletion" ask="Are you sure you want to delete this file?"
                          yesText="Accept" noText="Cancel" yesBtnClass="btn-default" @onComfirm="
                            deleteFileOrFolder(cv_file_form.path + item, 'file')
                            ">
                          <a>Delete</a>
                        </app-dialog>
                      </li>
                      <li>
                        <a @click.prevent="
                          DownloadCVFile(cv_file_form.path, item)
                          ">Download</a>
                      </li>
                    </ul>
                  </dropdown-menu>
                </div>
              </div>
              <div class="file-folder-item" v-else :key="index">
                <div class="brand" @click="enterDir(item)">
                  <img src="@/assets/file-icon/folder.svg" width="20" />
                </div>
                <div class="content" @click="enterDir(item)">
                  <div class="content-title">
                    <label>{{ item | validate }}</label>
                  </div>
                  <div class="date"></div>
                </div>
                <div class="options">
                  <dropdown-menu>
                    <ul>
                      <li>
                        <app-dialog title="File Deletion" ask="Are you sure you want to delete this file?"
                          yesText="Accept" noText="Cancel" yesBtnClass="btn-default" @onComfirm="
                            deleteFileOrFolder(
                              cv_file_form.path + item + '/',
                              'folder'
                            )
                            ">
                          <a>Delete</a>
                        </app-dialog>
                      </li>
                    </ul>
                  </dropdown-menu>
                </div>
              </div>
            </template>
            <div v-if="cv_file_manager.length == 0" class="">
              No file or Folder found in this directory
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End -->

    <!-- Add and update cv -->
    <div class="cvs-form-widget" v-if="show_add_cv_modal">
      <div class="upload-cv-panel" v-if="section_type == 'all-cv'">
        <div class="widget-title">Add CV template</div>
        <div class="widget-body">
          <div class="input-group">
            <label>CV Name</label>
            <input type="text" v-model="form.cv_name" class="input" />
          </div>
          <div class="input-file-group">
            <label>File</label>
            <div class="file-input-widget">
              <div class="file-input">
                <upload :crop="false" @onFileSelected="setCVFile" caption="Add File" remove_caption="Remove File" />
              </div>
              <div class="helper-text">
                The CV document to be uploaded, must respect the template
                structure of
                <a href="#" @click.prevent="download('default', 1)">the original copy</a>
                provided which is the
                <a target="_brank" href="https://jinja.palletsprojects.com/en/2.11.x/">Jinja template engine
                  structure.</a>
              </div>
            </div>
          </div>
          <div class="replace-input-group">
            <input id="replace-cv-input" v-model="replace_exist_cv" type="checkbox" />
            <label for="replace-cv-input">Replace existing CV</label>
          </div>
          <div class="cvs-items" v-if="replace_exist_cv">
            <div class="cv-item" v-for="(item, index) in cvs_data" :key="index">
              <div class="cv-item-header">
                <label>{{ item.alias | validate }}</label>
                <input type="radio" name="cv" v-model="form.cv_to_replace" :value="item.id" :id="`cv_${index}`" />
                <dropdown-menu>
                  <ul>
                    <li>
                      <a href @click.prevent="download('custom', item.name)">Download</a>
                    </li>
                    <li>
                      <a href @click.prevent="selectCV(item)">Edit</a>
                    </li>
                    <li>
                      <a href @click.prevent="appyTemp('custom', item.id)">Appy</a>
                    </li>
                    <li>
                      <a href @click.prevent="removeTemp(item.id, item.name)">Remove</a>
                    </li>
                  </ul>
                </dropdown-menu>
              </div>
              <div class="cv-item-body">
                <img src="@/assets/images/temp_docs/new/cv_tumbnail.svg" />
              </div>
            </div>
          </div>
        </div>
        <div class="widget-option">
          <consultfied-button class="btn-save" :loading="is_loading" @click="saveCV()">Save</consultfied-button>
          <button class="cancel" @click="show_add_cv_modal = false">
            Cancel
          </button>
        </div>
      </div>
      <div class="upload-cv-panel" v-if="section_type == 'my-cv'">
        <div class="widget-title">Upload CV</div>
        <div class="widget-body">
          <div class="input-group">
            <label>File Name</label>
            <input type="text" v-model="cv_file_form.name" class="input" />
          </div>
          <div class="input-file-group">
            <label>File</label>
            <div class="file-input-widget">
              <div class="file-input">
                <upload :crop="false" @onFileSelected="setActualFile" caption="Add File" remove_caption="Remove File" />
              </div>
              <div class="helper-text"></div>
            </div>
          </div>
        </div>
        <div class="widget-option">
          <consultfied-button class="btn-save" :loading="is_loading" @click="saveFile()">Save</consultfied-button>
          <button class="cancel" @click="show_add_cv_modal = false">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <!-- Apply cv modal -->
    <div class="apply-cv-overlay" v-if="show_cv_apply_cv_modal">
      <div class="apply-cv-modal">
        <div class="apply-cv-header">
          <h4>Apply template to consultant</h4>
        </div>
        <div class="apply-cv-body">
          <div class="input-group">
            <div class="check-option">
              <input v-model="apply_form.apply_all" type="checkbox" id="apply-all" />
              <label for="apply-all">Apply to all</label>
            </div>
            <div class="search-container" v-if="!apply_form.apply_all">
              <img src="@/assets/icons/search.svg" alt />
              <input type="text" placeholder="Type in to Search…" v-model="search_consultant_member" />
            </div>
            <div v-show="company_member_list &&
              company_member_list.length > 0 &&
              search_consultant_member
              " v-if="!apply_form.apply_all" class="search_dropdown__body">
              <div class="dropdown__item" v-for="(person, i) in company_member_list" :key="i" @click="addMate(person)">
                <img v-if="person.profile_picture" :src="$fullUrl('images/profiles/' + person.profile_picture)"
                  alt="picture" />
                <img v-else src="@/assets/avatar.png" alt />
                <div class="text">
                  <span>{{ person.first_name + " " + person.last_name | validate }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="pitch-body" v-if="added_member_list.length > 0 && !apply_form.apply_all">
            <div class="pitch-fieldset">
              <div class="collaboraters-widget">
                <div class="item" v-for="(item, i) in added_member_list" :key="i">
                  <img v-if="item.picture" :src="$fullUrl('images/profiles/' + item.picture)" alt="picture"
                    class="profile-img" />
                  <img v-else src="@/assets/avatar.png" alt class="profile-img" />
                  <span class="name">{{ item.names | validate }}</span>
                  <button v-if="item.closable" class="remove-pitch-btn" @click="removeMate(item.id, i)">
                    <img src="@/assets/icons/close.svg" />
                  </button>
                </div>
              </div>
            </div>
            <label class="sectected-pitch-count">{{ added_member_list.length | validate }} Consultants selected</label>
          </div>
        </div>
        <div class="apply-cv-option">
          <consultfied-button class="btn-save" @click="saveApplieCv()"
            :loading="appy_cv_member_loading">Save</consultfied-button>
          <button class="btn-back" @click="show_cv_apply_cv_modal = false">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- Wizard -->
    <div class="wizard-overlay" v-if="show_wizard_modal">
      <div class="wizard-modal">
        <div class="wizard-header">
          <button class="btn-back" @click="prevWizard()" v-if="!wizard[0].active">
            <img src="@/assets/icons/wizard-back.svg" />
          </button>
          <h3 class="wizard-title" v-if="wizard[0].active">
            Create, Upload and Share
          </h3>
          <h3 class="wizard-title" v-if="wizard[1].active">
            Customisable and Downloadable
          </h3>
          <h3 class="wizard-title" v-if="wizard[2].active">
            Let us do it for you
          </h3>
          <button class="btn-close" @click="closeWizardModal()">&times;</button>
        </div>
        <div class="wizard-body">
          <div class="screen" v-if="wizard[0].active">
            <img src="@/assets/cvs_wizard/screen_1.svg" />
            <p>
              <b>Create, Upload and Share</b> your consultants CVs
              professionally than before…
            </p>
          </div>
          <div class="screen" v-if="wizard[1].active">
            <img src="@/assets/cvs_wizard/screen_2.svg" />
            <p>
              Enjoy
              <b>Customisable and Downloadable</b>
              CV templates in .doc and .json formats.
            </p>
          </div>
          <div class="screen" v-if="wizard[2].active">
            <img src="@/assets/cvs_wizard/screen_3.svg" />
            <p>
              Let us
              <b>Build your CV for you</b>, the way you want it.
            </p>
          </div>
          <div class="dots">
            <div v-for="(item, index) in wizard" :key="index" class="dot" :class="{ active: item.active }"></div>
          </div>
        </div>
        <div class="wizard-option">
          <button class="btn-next" @click="nextWizard()" v-if="!wizard[2].active">
            Next
          </button>
          <button class="btn-next" @click="nextWizard()" v-if="wizard[2].active">
            Get Started
          </button>
          <a href class="how-labele">How it works</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import HelpToolTip from "@/components/helper/HelpToolTip.vue";
import upload from "@/components/Partials/Uploader.vue";

export default {
  name: "cvs",
  components: {
    dropdownMenu,
    appDialog,
    consultfiedButton,
    HelpToolTip,
    upload,
  },
  props: {},
  data: () => {
    return {
      show_add_cv_modal: false,
      replace_exist_cv: false,
      form: {
        id: null,
        cv_name: "",
        cv_file: null,
        cv_file_url: "",
        cv_to_replace: 0,
      },
      apply_form: {
        apply_all: false,
        type: "",
        temp_name: "",
        members: [],
      },
      cv_file_form: {
        id: null,
        name: "",
        path: "/",
        file: null,
        file_url: "",
      },
      show_cv_apply_cv_modal: false,
      is_loading: false,
      cvs_data: [],
      appy_cv_member_loading: false,
      added_member_list: [],
      company_member_list: [],
      search_consultant_member: "",
      wizard_active_screen: -1,
      wizard: [{ active: false }, { active: false }, { active: false }],
      show_wizard_modal: true,
      section_type: "all-cv",
      create_folder_widget: false,
      folder_form: {
        id: null,
        name: "",
        path: "/",
      },
      cv_file_manager: [],
    };
  },
  mounted() {
    let vm = this;
    vm.getCvsData();
    vm.nextWizard();
    let path = vm.cv_file_form.path;
    vm.getCVFileManager(path);
  },
  computed: {},
  watch: {
    search_consultant_member: function (query) {
      this.searchPeople(query);
    },
    replace_exist_cv: function (val) {
      if (val == false) {
        this.form.cv_to_replace = 0;
      }
    },
  },
  methods: {
    fileExt(file_name) {
      return file_name.split(".").pop();
    },
    enterDir(item) {
      let vm = this;
      let path = (vm.cv_file_form.path = vm.cv_file_form.path + item + "/");
      vm.getCVFileManager(path);
    },
    isFile(file_name) {
      let vm = this;
      return file_name.slice(
        (Math.max(0, file_name.lastIndexOf(".")) || Infinity) + 1
      )
        ? true
        : false;
    },
    DownloadCVFile(path, file_name) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_DOWNLOAD_CV_FILE", { path: path, name: file_name })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file_name); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    DirBack() {
      let vm = this;
      const path = vm.cv_file_form.path.split("/");
      if (path.length > 1) {
        let index = path.length - 2;
        path.splice(index, 1);
        var path_string = path.join("/");
        vm.cv_file_form.path = path_string;
        vm.getCVFileManager(vm.cv_file_form.path);
      } else {
        var path_string = "/";
        vm.cv_file_form.path = path_string;
        vm.getCVFileManager(vm.cv_file_form.path);
      }
    },
    deleteFileOrFolder(path, type) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_CV_DELETE_FILE_FOLDER", { path: path, type: type })
        .then((responce) => {
          let path = vm.cv_file_form.path;
          vm.getCVFileManager(path);
          vm.$notify({
            group: "status",
            title: "Important message",
            text: type + " was deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Error while deleting " + type + ", Please try again.",
            type: "warn",
            duration: 3000,
          });
        });
    },
    getCVFileManager(path) {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("COMPANY_GET_MY_CV", { path: path })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.cv_file_manager = responce.data;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
          console.log(error);
        });
    },
    createFolder() {
      let vm = this;
      vm.folder_form.path = vm.cv_file_form.path;
      if (!vm.folder_form.id) {
        vm.$store
          .dispatch("COMPANY_ADD_NEW_FOLDER", vm.folder_form)
          .then((responce) => {
            vm.create_folder_widget = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Important message",
              text: "New folder was added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while adding new folder, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.$store
          .dispatch("COMPANY_UPDATE_FOLDER", vm.folder_form)
          .then((responce) => {
            vm.create_folder_widget = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Important message",
              text: "Folder was updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while updating folder, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    saveFile() {
      let vm = this;
      let form_data = new FormData();
      form_data.append("id", vm.cv_file_form.id);
      form_data.append("name", vm.cv_file_form.name);
      form_data.append("path", vm.cv_file_form.path);
      if (vm.cv_file_form.file) {
        form_data.append(
          "file",
          vm.cv_file_form.file,
          vm.cv_file_form.file.name
        );
      }
      if (!vm.cv_file_form.id) {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_ADD_NEW_CV_FILE", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Important message",
              text: "New cv file was added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while adding cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_UPDATE_CV_FILE", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            let path = vm.cv_file_form.path;
            vm.getCVFileManager(path);
            vm.$notify({
              group: "status",
              title: "Important message",
              text: "New cv file was updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while updating cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    setActualFile(file) {
      let vm = this;
      if (file) {
        vm.cv_file_form.file = file;
      }
    },
    switchSection(section) {
      let vm = this;
      vm.section_type = section;
    },
    closeWizardModal() {
      let vm = this;
      vm.show_wizard_modal = false;
    },
    prevWizard() {
      let vm = this;
      vm.wizard_active_screen -= 1;
      vm.wizard.forEach((item) => {
        item.active = false;
      });
      if (vm.wizard_active_screen > -1) {
        vm.wizard[vm.wizard_active_screen].active = true;
      }
    },
    nextWizard() {
      let vm = this;
      vm.wizard_active_screen += 1;
      vm.wizard.forEach((item) => {
        item.active = false;
      });
      if (vm.wizard_active_screen < vm.wizard.length) {
        vm.wizard[vm.wizard_active_screen].active = true;
      } else {
        vm.closeWizardModal();
        vm.wizard_active_screen = -1;
      }
    },
    selectCV(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.cv_name = item.alias;
      vm.show_add_cv_modal = true;
    },
    removeTemp(id, name) {
      let vm = this;
      vm.$store
        .dispatch("COMPANY_REMOVE_CV", { id: id, temp_name: name })
        .then((response) => {
          vm.getCvsData();
        })
        .catch((error) => console.log(error));
    },
    download(type, file_name) {
      let vm = this;
      let name = "";
      if (type == "default") {
        name = "cvs/template_" + file_name + ".docx";
      } else {
        name = file_name;
      }
      vm.$store
        .dispatch("COMPANY_DOWNLOAD_CV", { name: name })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file_name + ".docx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    addMate(member) {
      let vm = this;
      let obj = {
        id: member.id,
        names: member.first_name + " " + member.last_name,
        picture: member.profile_picture,
        closable: true,
      };
      vm.added_member_list.push(obj);
      vm.search_consultant_member = "";
    },
    removeMate(id, i) {
      let vm = this;
      vm.added_member_list.splice(i, 1);
    },
    searchPeople(query) {
      let vm = this;
      vm.$store
        .dispatch("SEARCH_FOR_COMPANY_MEMBERS", { query: query })
        .then((responce) => {
          vm.company_member_list = responce.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveApplieCv() {
      let vm = this;
      vm.appy_cv_member_loading = true;
      vm.apply_form.members = vm.added_member_list.map((item) => item.id);
      vm.$store
        .dispatch("COMPANY_APPLY_CV", vm.apply_form)
        .then((responce) => {
          vm.appy_cv_member_loading = false;
          vm.show_cv_apply_cv_modal = false;
          vm.$notify({
            group: "status",
            title: "Important message",
            text: "Now cv was applied successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.appy_cv_member_loading = false;
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Error while appliying cv, Please try again.",
            type: "warn",
            duration: 3000,
          });
          console.log(error);
        });
    },
    appyTemp(type, temp_name) {
      let vm = this;
      vm.apply_form.type = type;
      if (type == "default") {
        vm.apply_form.temp_name = `cvs/template_${temp_name}.docx`;
      } else {
        vm.apply_form.temp_name = temp_name;
      }
      // May this option will be updated soon
      // vm.show_cv_apply_cv_modal = true;
      vm.$store
        .dispatch("COMPANY_APPLY_CV", vm.apply_form)
        .then((responce) => {
          vm.$notify({
            group: "status",
            title: "Important message",
            text: "Now cv was applied successfully",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Something wrong",
            text: "Error while appliying cv, Please try again.",
            type: "warn",
            duration: 3000,
          });
        });
    },
    saveCV() {
      let vm = this;
      let form_data = new FormData();
      form_data.append("cv_name", vm.form.cv_name);
      form_data.append("cv_to_replace", vm.form.cv_to_replace);
      form_data.append("id", vm.form.id);
      if (vm.form.cv_file) {
        form_data.append("cv_file", vm.form.cv_file, vm.form.cv_file.name);
      }
      if (!vm.form.id) {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_ADD_NEW_CV", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            vm.getCvsData();
            vm.$notify({
              group: "status",
              title: "Important message",
              text: "New cv was added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while adding cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.is_loading = true;
        vm.$store
          .dispatch("COMPANY_UPDATE_CV", form_data)
          .then((responce) => {
            vm.is_loading = false;
            vm.show_add_cv_modal = false;
            vm.getCvsData();
            vm.$notify({
              group: "status",
              title: "Important message",
              text: "New cv was updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.is_loading = false;
            vm.$notify({
              group: "status",
              title: "Something wrong",
              text: "Error while updating cv, Please try again.",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    setCVFile(file) {
      let vm = this;
      if (file) {
        vm.form.cv_file = file;
      }
    },
    getCvsData() {
      let vm = this;
      vm.$store
        .dispatch("GET_USER_COMPANY_CV")
        .then((responce) => {
          vm.cvs_data = responce.data;
          console.log(vm.cvs_data);
        })
        .catch((error) => {
          console.error({ error });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.cvs-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  .company-profile-container {
    padding: 1px;
    width: 100%;

    @media (min-width: 300px) and (max-width: 630px) {
      padding: 15px;
    }

    .company-profile-body {
      border-radius: 5px;
      margin-bottom: 20px;

      .cvs-item-header {
        display: flex;
        justify-content: space-between;
        padding: 6px 0px;

        .title {
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 16px !important;
            font-weight: 800;
          }
        }

        .options {
          display: flex;
          align-items: center;

          .add-btn {
            color: #1885ad;
            display: flex;
            font-style: italic;
            outline: none;
            margin-right: 15px;
          }
        }
      }

      .cvs-items {
        margin-top: 10px;
        display: grid;
        grid-template-columns: 31.3333% 31.33333% 31.3333%;
        grid-gap: 20px;

        @media (min-width: 300px) and (max-width: 630px) {
          grid-template-columns: 48% 48%;
        }

        .cv-item {
          background: #fff;
          border-radius: 5px;

          .cv-item-header {
            display: flex;
            justify-content: space-between;
            padding: 0px 5px;
            align-items: flex-start;
            border-bottom: 1px solid #ddd;

            label {
              width: 99%;
              padding-top: 9px;
              font-size: 15px;
              align-items: center;
              display: flex;
              padding-left: 8px;
            }
          }

          .cv-item-body {
            padding: 10px 0px;

            img {
              width: 100%;
            }
          }
        }
      }

      .forder-section {
        background: #fff;
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 5px;

        .header {
          display: flex;
          align-items: center;
          font-size: 16px;
          justify-content: space-between;
          margin-bottom: 20px;

          .option {
            .btn-create-folder {
              background: transparent;
              border: none;
              color: #2090ba;
              outline: none;
            }
          }
        }

        .path {
          font-size: 11px;
          margin-bottom: 15px;
          color: rgb(133, 133, 133);
        }

        .body {
          .folder-creation-input {
            display: flex;
            justify-content: space-between;
            margin-bottom: 29px;
            border-radius: 5px;
            padding: 7px;
            align-items: center;

            .brand {
              width: 60px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .content {
              width: calc(100% - 128px);
              display: flex;
              justify-content: space-between;

              .folder-name-input {
                width: 100%;
                height: 45px;
                border: 1px solid #ddd;
                padding: 0px 10px;
                outline: none;
              }
            }

            .options {
              width: 50px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
            }
          }

          .file-folder-item {
            display: flex;
            justify-content: space-between;
            background: #f5f5f5;
            margin-bottom: 8px;
            border-radius: 5px;
            padding: 7px;
            cursor: pointer;

            .brand {
              width: 60px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .content {
              width: calc(100% - 50px);
              display: flex;
              justify-content: space-between;
              padding-top: 10px;
            }

            .options {
              width: 15px;
            }
          }
        }
      }
    }
  }

  .cvs-form-widget {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background: rgba(0, 0, 0, 0.8);
    z-index: 99999;
    display: flex;
    justify-content: center;
    padding: 85px;
    overflow-y: auto;

    @media (min-width: 300px) and (max-width: 630px) {
      padding: 85px 10px;
    }

    .upload-cv-panel {
      background: #fff;
      width: 600px;
      min-height: 100px;
      border-radius: 5px;
      display: inline-table;
      padding: 40px;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        padding: 15px;
      }

      .widget-title {
        font-size: 18px;
      }

      .widget-body {
        margin-top: 20px;

        .input-group {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;

          .input {
            border: 1px solid #ddd;
            height: 45px;
            border-radius: 5px;
            outline: none;
            padding: 0px 15px;
          }
        }

        .input-file-group {
          .file-input-widget {
            display: grid;
            grid-template-columns: 200px calc(98% - 200px);
            grid-column-gap: 20px;

            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 100%;
            }

            .helper-text {
              padding-left: 10%;

              @media (min-width: 300px) and (max-width: 630px) {
                grid-template-columns: 100%;
                padding-left: 0px;
              }
            }
          }
        }

        .replace-input-group {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 20px;

          label {
            margin-left: 5px;
            margin-top: 4px;
          }
        }

        .cvs-items {
          margin-top: 10px;
          display: grid;
          grid-template-columns: 31.3333% 31.33333% 31.3333%;
          grid-gap: 20px;

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 48% 48%;
          }

          .cv-item {
            background: #fff;
            border-radius: 5px;
            border: 1px solid #ddd;

            .cv-item-header {
              display: flex;
              justify-content: space-between;
              padding: 0px 5px;
              align-items: center;
              border-bottom: 1px solid #ddd;

              label {
                width: 99%;
                padding-top: 9px;
                font-size: 15px;
                align-items: center;
                display: flex;
                padding-left: 8px;
              }
            }

            .cv-item-body {
              padding: 10px 0px;

              img {
                width: 100%;
              }
            }
          }
        }
      }

      .widget-option {
        margin-top: 30px;
        display: flex;
        align-items: center;

        .btn-cancel {
          color: #1ba5a4;
          cursor: pointer;
          font-weight: normal;
          height: 40px;
          padding: 3px 20px;
          font-size: 14px;
          width: 100px;
        }

        .btn-save {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20px;

          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }

  .apply-cv-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    padding-top: 100px;

    .apply-cv-modal {
      width: 500px;
      display: inline-table;
      background: #fff;
      border-radius: 5px;

      .apply-cv-header {
        padding: 15px 20px;

        h4 {
          font-size: 17px;
        }
      }

      .apply-cv-body {
        padding: 15px 20px;

        .input-group {
          display: flex;
          flex-direction: column;
          position: relative;

          .check-option {
            display: flex;
            align-items: center;

            input {
              margin-right: 10px;
            }
          }

          .search-container {
            border: 1px solid #ccc;
            height: 45px;
            display: flex;
            align-items: center;
            padding: 0px 10px;
            border-radius: 5px;

            img {
              width: 25px;
              height: 25px;
            }

            input {
              height: 45px;
              width: 100%;
              padding-left: 15px;
              outline: none;
            }
          }

          .search_dropdown__body {
            position: absolute;
            top: 68px;
            width: 100%;
            background: #fff;
            z-index: 999;
            box-shadow: 0px 4px 7px rgb(49, 49, 49);
            height: 194px;
            overflow-y: auto;
            border-radius: 5px;

            .dropdown__item {
              display: flex;
              align-items: center;
              border-bottom: 1px solid #e8e8e8;
              padding: 20px 10px;
              cursor: pointer;

              &:hover {
                background: #e8e8e8;
              }

              img {
                height: 30px;
                width: 30px;
                object-fit: cover;
                margin-right: 15px;
                border-radius: 50%;
              }

              .text {
                span {
                  font-size: 15px;
                }
              }
            }
          }
        }

        .pitch-body {
          .pitch-body-title {
            font-size: 12px;
            color: #031019;
          }

          .pitch-fieldset {
            border-radius: 5px;
            padding: 4px 0px;

            .collaboraters-widget {
              padding: 10px 0px;
              display: flex;
              flex-wrap: wrap;

              .item {
                background: #1ba5a4 0% 0% no-repeat padding-box;
                border-radius: 20px;
                display: flex;
                align-items: center;
                padding: 4px 4px;
                margin-right: 8px;
                margin-bottom: 8px;
                position: relative;

                .profile-img {
                  width: 26px;
                  height: 26px;
                  border-radius: 50%;
                  margin-right: 5px;
                }

                .name {
                  color: #fff;
                  margin-right: 10px;
                }

                .remove-pitch-btn {
                  background: crimson;
                  border-radius: 50%;
                  height: 20px;
                  width: 20px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  top: -11px;
                  right: -7px;
                }
              }
            }
          }

          .sectected-pitch-count {
            font-size: 14px;
            color: #6e6e6e;
            margin-top: 10px;
            display: block;
          }
        }
      }
    }

    .apply-cv-option {
      padding: 15px 20px;
      display: flex;

      .btn-save {
        width: 100px;
        height: 45px;
        background: #1890a9 0% 0% no-repeat padding-box;
        border-radius: 4px;
        color: #fff;
        outline: none;
        margin-right: 20px;
        display: center;
        justify-content: center;
      }

      .btn-back {
        height: 45px;
        border-radius: 4px;
        color: #1890a9;
        outline: none;
      }
    }
  }

  // wizard
  .wizard-overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999999;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    padding-top: 100px;
    overflow-y: auto;

    @media (min-width: 300px) and (max-width: 630px) {
      padding-top: 50px;
    }

    .wizard-modal {
      width: 500px;
      display: inline-table;
      background: #fff;
      border-radius: 5px;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
        display: unset;
      }

      .wizard-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        background: #1ba5a4;
        padding: 0px 20px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;

        .btn-back {
          font-size: 15px;
          font-weight: 800;
          color: #fff;
          outline: none;

          img {
            width: 11px;
            margin-top: 8px;
          }
        }

        .wizard-title {
          color: #fff;
        }

        .btn-close {
          font-size: 37px;
          font-weight: 800;
          color: #ddd;
        }
      }

      .wizard-body {
        padding: 25px 80px;

        .screen {
          display: flex;
          flex-direction: column;
          align-items: center;

          img {
            width: 180px;
            height: 200px;
            object-fit: contain;
          }

          p {
            text-align: center;
            margin-top: 25px;
          }
        }

        .dots {
          display: flex;
          align-items: center;
          justify-content: center;

          .dot {
            height: 6px;
            width: 6px;
            background: #707070;
            margin-right: 10px;
            border-radius: 50%;
            transition: 1s ease-in-out;

            &.active {
              border-radius: 2px;
              width: 20px;
              transition: 1s ease-in-out;
            }
          }
        }
      }

      .wizard-option {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding-bottom: 15px;

        .btn-next {
          width: 163px;
          height: 45px;
          background: #1ba5a4;
          box-shadow: 0px 3px 6px #00000029;
          border-radius: 5px;
          color: #fff;
          margin-bottom: 13px;
          outline: none;
        }

        .how-labele {
          color: #2090ba;
          text-transform: none;
          text-decoration: none;
        }
      }
    }
  }
}
</style>